export const llmSelectedTestCases = [
  {
    key : "row-select",
    display_name : "",
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
    cellStyles: {
      width: 0,
    },
    headerStyles: {
      background : "#7593F2",
      color: "#FFFFFF",
      width : "4%",
      "font-weight": 600
    }
  },
  {
    display_name: "Test Case ID",
    key: "testCaseId",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      width: "10%",
      "font-weight": 600,
    },
  },
  {
    display_name: "Test Case Desciption ",
    key: "testCase",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "15%",
    },
  },
   {
    display_name: "Prerequisites",
    key: "prerequisites",
    type: "orderd-list",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "13%",
    },
    _editConfig: {
      type: 'textarea'
    }
  },
   {
    display_name: "Test Steps",
    key: "testScenario",
    type: "orderd-list",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "15%",
    },
    _editConfig: {
      type: 'textarea'
    }
  },
   {
    display_name: "Expected Results",
    key: "expectedResult",
    type: "orderd-list",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
      width: "15%",
    },
    _editConfig: {
      type: 'textarea'
    }
  },
  {
    display_name: "User Story Id",
    key: "key",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      
      color: "white",
      width: '10%'
    },
  },
  {
    display_name: "User Story",
    key: "storydesc",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      
      color: "white",
      width: '15%'
    },
  },
];
